<template>
    <div class="detailInfo">
        <!-- <h1>{{ drugName }}</h1> -->
        <div class="thumbnail" ref="images">
            <div class="pic" v-for="item in picList" :key="item">
                <img @click="clickPic" :src="cloudPic(item, 'yaocai')" />
            </div>
        </div>
        <div class="detail-content">
            <div class="section" v-for="obj in infoList" :key="obj.id">
                <div class="anchor-point"></div>
                <h2>{{ obj.zhaiLu }}：{{ drugName }}</h2>
                <div v-for="(item, index) in keyAndValue" :key="item" :class="{ highLigh: item == '各家论述' }">
                    <div v-if="obj[index]" class="item">
                        <div class="item-name">{{ item }}:</div>
                        <div class="item-content" v-html="obj[index]"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <perfect-scrollbar ref="drugScrollbar" @ps-scroll-y="onScroll" :options="{ suppressScrollX: true }">
    </perfect-scrollbar> -->
</template>

<script>
import viewer from "viewerjs";
import { mapGetters } from "vuex";
// eslint-disable-next-line no-undef
let jq = $;
export default {
    props: {
        drugName: {
            type: String,
            default: ""
        },
    },
    computed: {
        ...mapGetters(['drugInfoListIndex'])
    },
    watch: {
        drugName() {
            this.getData();
        },
        drugInfoListIndex() {
            this.isIndexChange = true;
            setTimeout(() => {
                this.isIndexChange = false;
            }, 500);
            this.goto();
        }
    },
    data() {
        return {
            isScroll: false,
            isIndexChange: false,
            picList: [],
            picView: null,
            infoList: [],
            anchorPoints: [],
            keyAndValue: {
                // mingCheng: "名称",
                pinYin: "拼音注音",
                bieMing: "别名",
                yingWenMing: "英文名",
                geJiaLS: "各家论述",
                chuChu: "出处",
                laiYuan: "来源",
                shengJingFB: "生境分布",
                yuanXingTai: "原形态",
                zaiPei: "栽培",
                xingZhuang: "性状",
                duXing: "毒性",
                huaXueCF: "化学成分",
                yaoLiZY: "药理作用",
                zhuCang: "贮藏",
                paoZhi: "炮制",
                jianBie: "鉴别",
                hanLiangCD: "含量测定",
                guiJing: "归经",
                xingWei: "性味",
                zhuYi: "注意",
                gongNengZZ: "功能主治",
                yongFaYL: "用法用量",
                zhiFa: "制法",
                chuFang: "处方",
                fuFang: "复方",
                linChuangYY: "临床应用",
                // geJiaLS: "各家论述",

                // shiJian: "时间",
                // guiGe: "规格",
                zhiJi: "制剂",
                beiZhu: "备注",
                zhaiLu: "摘录",
            }
        }
    },
    methods: {
        goto() {
            if (!this.isScroll) {
                window.scrollTo(0, this.anchorPoints[this.drugInfoListIndex] - 60)
            }
        },
        clickPic() {
            if (this.picView) this.picView.destroy();
            this.picView = new viewer(this.$refs.images);
        },
        addBr(str) {
            // return str ? str.replace(/(\[br\])|(\r\n)/ig, '<br/>') : str;
            return str ? str.replace(/(\[br\])|(\r\n)/ig, '<div class="br"></div>') : str;
        },
        toHtml(str) {
            if (!str) return "";
            if (this.keyword) {
                str = this.common.batchHighlightKeyword(str, this.keyword);
            }
            return str.replace(/\[alt\].*?\[\/alt\]/ig, "")
                .replace(/\[(.*?)\]/ig, '<$1>')
                .split(/\r\n/g)
                .join("");
        },
        getData() {
            this.$store.commit("drugInfoListIndex", 0)
            let obj = {
                drugName: this.drugName, // 药品名称 
            }
            this.picList = [];
            this.infoList = [];
            this.$store.commit("showLoading")
            this.api("listMedicinalMaterialsDetail", obj).then(res => {
                this.$store.commit("hideLoading")
                this.infoList = res.result.map((i, index) => {
                    for (const key in i) {
                        if (Object.hasOwnProperty.call(i, key)) {
                            let e = i[key];
                            if (key == 'tuPian' && e) {
                                this.picList = this.picList.concat(e.split(","))
                            }
                            // i[key] = this.addBr(this.toHtml(e));
                            i[key] = this.toHtml(this.addBr(e));
                        }
                    }
                    i.active = index ? false : true;
                    return i;
                });
                this.$store.commit("drugInfoList", this.infoList);
                setTimeout(() => {
                    this.getAnchorPoint();
                }, 1000);
            })
        },
        getAnchorPoint() {
            // let offset = jq(this.$refs.drugScrollbar.$el).offset().top;
            // this.anchorPoints = [...this.$el.querySelectorAll(".anchor-point")].map(i => jq(i).offset().top - offset)
            this.anchorPoints = [...this.$el.querySelectorAll(".anchor-point")].map(i => jq(i).offset().top)
        },
        onScroll() {
            if (this.isIndexChange) return;
            this.isScroll = true;
            setTimeout(() => {
                this.isScroll = false;
            }, 500);
            // let top = this.$refs.drugScrollbar.$el.scrollTop;
            let top = window.scrollY;
            let index = [...this.anchorPoints, 10000].findIndex(i => i > top) - 1
            if (index < 0) index = 0
            this.$store.commit("drugInfoListIndex", index)
        }
    },
    created() {
        this.getData();
    },
    mounted() {
        window.addEventListener("scroll", this.onScroll)
    },
    destroyed() {
        window.removeEventListener("scroll", this.onScroll)
    },
}
</script>

<style lang="scss" scoped>
.highLigh .item {
    background: #42b88311;
    border-radius: 5px;
    padding: 5px;
}
</style>